import { React, Styled } from '@common/3rd';
import { DeskComponentRegistry, CheckableWidget } from '@component';
import { CheckableWidgetState, DeskTreeComponents, DeskTreeProps } from '@my-types';
// import { StyledComponents } from '@styles';
// import { RcTree }from './desk-rc-tree';

import Tree from 'rc-tree';
// let createReactClass = require('create-react-class');
require('rc-tree/assets/index.css');

type TreeProps = {
	checkable?: boolean;
	expand?: boolean;
	title?: string;
	defaultExpandedKeys?: [];
	defaultSelectedKeys?: [];
	defaultCheckedKeys?: [];
}

type TreeState = {
	defaultExpandedKeys: [],//默认展开 keys节点
	defaultSelectedKeys: [],//默认选中(高亮) keys节点
	defaultCheckedKeys: [],//默认Checked keys节点
	expandedKeys: [],
	selectedKeys: [],
	checkedKeys: []
}

/**
 * 标准树组件
 */
class DeskTree<P extends DeskTreeProps & TreeProps, S extends CheckableWidgetState & TreeState, C extends DeskTreeComponents> extends CheckableWidget<P, S, C> {
	treeRef: React.RefObject<any>;
	selectedKey: any;

	constructor(props: any, context?: any) {
		super(props, context);
		this.treeRef = React.createRef();
	}
	protected initComponents(): C {
		return {
			Box: Styled.div.attrs({
				'data-widget': 'desk-tree'
			})`
				${props => this.renderCSS(props.theme)}
			`,
		} as C;
	}
	render() {
		const C = this.getComponents();
		return (
			<C.Box>
				{this.renderTree()}
			</C.Box>
		);
	}
	renderTree() {
		// const switcherIcon = (obj: any) => {
		// 	console.log(obj);
		// 	if (obj.isLeaf === false) {
		// 		return <i className="fa fa-plus-square-o" />
		// 	}
		// 	return <i className="fa fa-minus-square-o" />
		// };
		return (
			<div style={{ margin: '0 20px' }}>
				<h2>{this.getTreeTitle()}</h2>
				<Tree
					// switcherIcon={switcherIcon}
					showIcon={false}
					checkable={this.getCheckable()}
					defaultExpandAll={this.getExpandedAll()}
					defaultExpandedKeys={this.state.defaultExpandedKeys}
					defaultSelectedKeys={this.state.defaultSelectedKeys}
					defaultCheckedKeys={this.state.defaultCheckedKeys}
					onExpand={this.onExpand.bind(this)}
					onSelect={this.onSelect.bind(this)}
					onCheck={this.onCheck.bind(this)}
					treeData={this.getTreeData()}
				>
				</Tree>
			</div>
		);
	}
	protected onExpand(expandedKeys: any) {
		this.setState({ expandedKeys: expandedKeys }, () => {
			this.setValueToModel(this.state);
		});
	}
	protected onSelect(selectedKeys: any, info: any) {
		this.setState({ selectedKeys: selectedKeys }, () => {
			this.setValueToModel(this.state);
		});
	}
	protected onCheck(checkedKeys: any, info: any) {
		this.setState({ checkedKeys: checkedKeys }, () => {
			this.setValueToModel(this.state);
		});
	}
	protected getDefaultExpandedKeys(): any {
		return this.props.defaultExpandedKeys || [];
	}
	protected getDefaultSelectedKeys(): any {
		return this.props.defaultSelectedKeys || [];
	}
	protected getDefaultCheckedKeys(): any {
		return this.props.defaultCheckedKeys || [];
	}
	protected getTreeData(): any {
		return this.props.tree || [];
	}
	protected getTreeTitle(): string | undefined {
		return this.props.title || '列表';
	}
	protected getCheckable(): boolean | undefined {
		return this.props.checkable === true;
	}
	protected getExpandedAll(): boolean | undefined {
		return this.props.expand === true;
	}
	protected doAfterCheckCompleted(): this {
		return this;
	}

	focus(): this {
		this.treeRef.current.focus();
		return this;
	}
}

DeskComponentRegistry.register({
	tree: DeskTree
});

export { DeskTree };
